import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import LoadingPage from "./LoadingPage";
import PageEight from "./PageEight";
// import jsonFile from "./rpt-pmt-temaProjek.json";

const PageSeven = ({ idJadwalCbt, idKelas, kodeTahunAjaran, schoolName }) => {
    const [fetching, setFetching] = useState(false);
    const [themeRecommended, SetThemeRecommended] = useState([]);
    const [openPage, setOpenPage] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_SEVEN, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                })
                .catch(function (error) {
                    console.error("Error Response Page Seven", error);
                });

            if (response) {
                if (response.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Seven ", responseAPI);
                    console.log("====================================");

                    SetThemeRecommended(responseAPI.listRekomandasiTemaProject);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <div>
            <div className="report-page">
                <div className="cardLine">
                    {/* header */}
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>07</span>
                        </div>
                        <div className="pnl-date">
                            https://eduprime.co.id/
                        </div>
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <span className="title-header2" style={{ color: '#015E56', fontSize: '25px', }}>Hasil Asesmen Diagnostik </span>
                            <p style={{ color: '#015E56', fontSize: '24px', fontWeight: '500', marginTop: '10px' }}>{schoolName} </p>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', }}>
                            <div className="label-sub-tit">
                                <span style={{ color: '#FFF', fontSize: '20px', fontWeight: '700' }}>SEKOLAH</span>
                            </div>
                        </div>
                    </div>
                    <Gap height={50} />

                    <div className="result">
                        <div>
                            <span style={{ fontSize: '24px', fontWeight: '700' }}>Rekomendasi Tema Project Pembelajaran Profil Pelajar Pancasila</span>
                            <p style={{ fontSize: '16px', fontWeight: '400', color: '#757575' }}>Dari hasil asesmen terkait survei karakter siswa berdasarkan aspek Profil Pelajar Pancasila, maka disarankan untuk melakukan Project Based Learning dengan urutan tema sebagai berikut:</p>
                        </div>
                        <Gap height={20} />
                        <GridInline width={"100%"}>
                            <GridInline width={"21%"}>
                                <GridInline width={"25%"}>
                                    <img src="/assets/image/pemetaan/Strongly.png" width={30} />
                                </GridInline>
                                <GridInline>
                                    <LabelTitle label={"Strongly Recommended"} size={15} bolder={600} color={"#6C757D"} />
                                </GridInline>
                            </GridInline>
                            <GridInline width={"5%"} />
                            <GridInline width={"21%"}>
                                <GridInline width={"25%"}>
                                    <img src="/assets/image/pemetaan/Recommended.png" width={30} />
                                </GridInline>
                                <GridInline>
                                    <LabelTitle label={"Recommended"} size={15} bolder={600} color={"#6C757D"} />
                                </GridInline>
                            </GridInline>
                            <GridInline width={"21%"}>
                                <GridInline width={"25%"}>
                                    <img src="/assets/image/pemetaan/Poorly.png" width={30} />
                                </GridInline>
                                <GridInline>
                                    <LabelTitle label={"Poorly Recommended"} size={15} bolder={600} color={"#6C757D"} />
                                </GridInline>
                            </GridInline>
                        </GridInline>
                        <Gap height={20} />
                        <div className="rekap-table">
                            <Table striped size="sm" style={{ fontSize: 14 }}>
                                <thead
                                    style={{
                                        backgroundColor: "#BEF264",
                                        fontSize: 15,
                                        textAlign: "center",
                                    }}
                                >
                                    <tr>
                                        <th width="25%" height="50">
                                            Tema Project
                                        </th>
                                        <th width="25%">Sasaran Profil Pelajar Pancasila</th>
                                        <th width="25%">Contoh Implementasi</th>
                                        <th width="25%">Rekomendasi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {themeRecommended.map((theme, i) => {
                                        return (
                                            <tr
                                                key={i}
                                                height="40"
                                                style={{
                                                    textAlign: "center",
                                                }}
                                            >
                                                <td>
                                                    <img
                                                        src={"/assets/image/pemetaan/tema/" + theme.imageTema + ".png"}
                                                        width={40}
                                                        style={{
                                                            marginBottom: 5,
                                                            marginTop: 5,
                                                        }}
                                                    />
                                                    <LabelTitle label={theme.tema} size={14} bolder={500} color={"#6C757D"} />
                                                </td>
                                                <td>
                                                    <img
                                                        src={"/assets/image/pemetaan/tema/" + theme.imageSasaran + ".png"}
                                                        width={40}
                                                        style={{
                                                            marginBottom: 5,
                                                            marginTop: 5,
                                                        }}
                                                    />
                                                    <LabelTitle label={theme.sasaran} size={14} bolder={500} color={"#6C757D"} />
                                                </td>
                                                <td>
                                                    <LabelTitle label={theme.implementasi} size={14} bolder={500} color={"#6C757D"} />
                                                </td>
                                                <td>
                                                    <img
                                                        src={"/assets/image/pemetaan/" + theme.rekomendasi + ".png"}
                                                        width={40}
                                                        style={{
                                                            marginBottom: 5,
                                                            marginTop: 5,
                                                        }}
                                                    />
                                                    <LabelTitle label={theme.rekomendasi} size={14} bolder={400} color={"#6C757D"} />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
                {/* <Gap height={40} />
                <div className="reportFooter">
                    <FooterReport color={"#1D3557"} date={dateTime} />
                </div> */}
            </div>

            {openPage ? <PageEight idJadwalCbt={idJadwalCbt} idKelas={idKelas} kodeTahunAjaran={kodeTahunAjaran} schoolName={schoolName} /> : <LoadingPage />}
        </div>
    );
};

export default PageSeven;
